module.exports = __webpack_public_path__ + "img/gry_7.1f228231.png";